import { Button, Modal } from "antd";
import { noop, capitalize } from "lodash";

import "./popups.scss";

export const PROGRAM_EXISTS = "PROGRAM_ALREADY-EXISTS";
export const SCORE_RANGES = "SCORE_RANGE_DESCRPTION";

export const PopUpType = ({ data, onClose = noop }: { data: any; onClose: any }) => {
  let type = data.type ?? "";
  if (type === PROGRAM_EXISTS) {
    return <ProgramAlreadyExists data={data} onClose={onClose} />;
  } else if (type === SCORE_RANGES) {
    return <ScoreRangesPopUp data={data} onClose={onClose} />;
  } else {
    return <></>;
  }
};

export const ProgramAlreadyExists = ({ data, onClose = noop }: { data: any; onClose: any }) => {
  return (
    <Modal wrapClassName="custom-action-modal close_btn" title={data.description ? "" : "A Program Already Exists"} centered open={data.open} footer={null} onCancel={onClose}>
      <p className="ui-program-exists__popup__content">
        <span>{data.description ? data.description : `You're marking a need for ${capitalize(data.programName)} Program, but an active program already exists for this patient. `}</span>
      </p>
    </Modal>
  );
};

const ScoreRange = ({ score }: any) => {
  return (
    <div className="ui-score__popup_ranges">
      <div className="ui-score__popup_ranges__header">
        <span className="ui-score__popup_ranges__header-score">{`Scores ${score.lower_bound} ${score.upper_bound ? `- ${score.upper_bound}` : ""} `}</span>
      </div>
      <div className="ui-score__popup_ranges__body">
        <span className="ui-score__popup_ranges__body-label">{capitalize(score.label)}</span>
        <span className="ui-score__popup_ranges__body-description">{score.description ? ` ${score.label ? '-' : ''} ${score.description}` : ""}</span>
      </div>
      <div className="ui-score__popup_ranges__seperator"></div>
    </div>
  );
};

export const ScoreRangesPopUp = ({ data = {}, onClose = noop }: { data?: any; onClose?: any }) => {
  let { open, scorePopupData } = data;


  return (
    <Modal
      wrapClassName="ui-score__popup"
      title={<span>{scorePopupData[0].title.split(':')[0]}<span className='ui-score__popup__sub_title'>{scorePopupData[0].title.split(':')[1] ? `: ${scorePopupData[0].title.split(':')[1]}` : ''}</span></span>}
      open={open}
      footer={[
        <div className="ui-score__popup__btn">
          <Button type="primary" size="large" className="f16 w500" onClick={onClose}>
            {`Close`}
          </Button>
        </div>,
      ]}
      onCancel={onClose}
      width = '30rem'
    >
      {scorePopupData.map((score: any) => {
        return <ScoreRange score={score} />;
      })}
    </Modal>
  );
};
